<template>
  <div class="content" v-loading="loading">
    <div class="transaction-details">
      <div class="header">
        <div>
          <div class="title">Account</div>
          <div class="title2">
            <span>{{ address }}</span>
            <el-tooltip
              popper-class="copyTips"
              content="Copy to clipboard"
              placement="top"
              effect="light"
              :visible-arrow="false"
            >
              <img
                @click="copyToClipboard(address)"
                class="copy"
                src="../assets/icon_copy_20@2x.png"
                alt=""
              />
            </el-tooltip>
            <el-popover
              placement="bottom"
              width="134px"
              trigger="hover"
              :visible-arrow="false"
              popper-class="copyTips"
            >
              <div class="qrcode">
                <img :src="qrCodeUrl" />
              </div>
              <img
                src="../assets/icon_Qr code_20@2x.png"
                slot="reference"
                alt=""
              />
            </el-popover>
          </div>
        </div>

        <div class="search-box">
          <el-input
            placeholder="Search accounts, transactions"
            v-model="searchQuery"
            class="input-box"
            @keyup.enter.native="claimToken"
          />
          <div
            class="claim-button"
            :class="{ 'claim-button-active': searchQuery }"
            @click="claimToken"
          >
            <img src="../assets/icon_search_28@2x.png" alt="" />
          </div>
        </div>
      </div>

      <div class="balance-box">
        <div class="title">Balance</div>
        <div class="title2">{{ balance }} CNHO</div>
      </div>

      <div class="info-box">
        <div class="title">Transactions</div>
        <el-table
          :data="mergedData"
          style="width: 100%"
          class="table"
          v-loading="tableLoading"
          empty-text="No Data"
        >
          <el-table-column label="TX Hash" width="225">
            <template slot-scope="scope">
              <div class="table-data">
                <img
                  src="../assets/icon_hint_fail_20@2x.png"
                  v-if="scope.row.state != 0"
                  alt=""
                />
                <span
                  class="green"
                  @click="jumpHash(scope.row.txHash)"
                  style="margin-left: 4px"
                  >{{ convertHash(scope.row.txHash) }}</span
                >
                <el-tooltip
                  popper-class="copyTips"
                  content="Copy to clipboard"
                  placement="top"
                  effect="light"
                  :visible-arrow="false"
                >
                  <img
                    @click="copyToClipboard(scope.row.txHash)"
                    class="copy"
                    src="../assets/icon_copy_20@2x.png"
                    alt=""
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Block"
            width="145"
            prop="block"
          ></el-table-column>
          <el-table-column label="Time(UTC+8)" width="165" prop="time">
          </el-table-column>
          <el-table-column label="From" width="195">
            <template slot-scope="scope">
              <div class="table-data">
                <span class="green" @click="jumpAccount(scope.row.from)">{{
                  convertHash(scope.row.from)
                }}</span>
                <el-tooltip
                  popper-class="copyTips"
                  content="Copy to clipboard"
                  placement="top"
                  effect="light"
                  :visible-arrow="false"
                >
                  <img
                    @click="copyToClipboard(scope.row.from)"
                    class="copy"
                    src="../assets/icon_copy_20@2x.png"
                    alt=""
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="To" width="214" :sort-method="sortTime">
            <template slot-scope="scope">
              <div class="table-data">
                <span class="green" @click="jumpAccount(scope.row.to)">{{
                  convertHash(scope.row.to)
                }}</span>
                <el-tooltip
                  popper-class="copyTips"
                  content="Copy to clipboard"
                  placement="top"
                  effect="light"
                  :visible-arrow="false"
                >
                  <img
                    @click="copyToClipboard(scope.row.to)"
                    class="copy"
                    src="../assets/icon_copy_20@2x.png"
                    alt=""
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Amount(CNHO)" align="right" width="215">
            <template slot-scope="scope">
              <div>
                <el-tooltip
                  popper-class="copyTips"
                  :content="scope.row.amount"
                  placement="top"
                  effect="light"
                  :visible-arrow="false"
                  v-if="isLongerThan12(scope.row.amount)"
                >
                  <span>{{ truncateString(scope.row.amount) }}</span>
                </el-tooltip>
                <span v-else>{{ scope.row.amount }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Fee (CNHO)" align="right" width="215">
            <template slot-scope="scope">
              <div>
                <el-tooltip
                  popper-class="copyTips"
                  :content="scope.row.fee"
                  placement="top"
                  effect="light"
                  :visible-arrow="false"
                  v-if="isLongerThan12(scope.row.fee)"
                >
                  <span>{{ truncateString(scope.row.fee) }}</span>
                </el-tooltip>
                <span v-else>{{ scope.row.fee }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <el-pagination
            class="account-pagination"
            background
            layout="prev, pager, next"
            :total="totalItems"
            :page-size="10"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
          >
          </el-pagination>
          <div class="jumper-box">
            <span>Page</span>
            <el-input
              v-model="jumperValue"
              size="mini"
              class="jumper-input"
              number
              @keyup.enter.native="handleChange"
            ></el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import Big from "big.js";
export default {
  data() {
    return {
      loading: true,
      tableLoading: true,
      searchQuery: "",
      searchQueryOld: "",
      showDetails: false,
      nothing: false,
      address: "",
      balance: "",
      jumperValue: "",
      qrCodeUrl: "",
      data1: [],
      data2: [],
      mergedData: [],
      currentPage: 1,
      fetchData2Page: 2,
      pageSize: 10,
      totalItems1: 0,
      totalItems2: 0,
      totalItems: 0,
      totalItems1IsExact: false,
    };
  },
  created() {
    // this.address = this.$route.params.id;
    // this.getAccounts();
  },
  mounted() {
    this.address = this.$route.params.id;
    this.getAccounts();
  },
  methods: {
    isLongerThan12(str) {
      return str.length > 12;
    },
    truncateString(str) {
      if (str.length <= 12) {
        return str;
      }
      return `${str.slice(0, 5)}......${str.slice(-5)}`;
    },
    sortTime(a, b) {
      return new Date(b.time) - new Date(a.time);
    },
    jumpHash(account) {
      const url = this.$router.resolve({
        name: "Transaction",
        params: { id: account },
      }).href;
      window.open(url, "_blank");
    },
    jumpAccount(account) {
      const url = this.$router.resolve({
        name: "Account",
        params: { id: account },
      }).href;
      window.open(url, "_blank");
    },
    balanceNumber(value, fix) {
      // 将数值转换为字符串
      let valueStr = value.toString();
      let bigValue = new Big(value);
      let integerPart, decimalPart;

      // 判断是否有小数点
      if (valueStr.includes(".")) {
        // 分离整数部分和小数部分
        [integerPart, decimalPart] = valueStr.split(".");

        // 组合整数部分和小数部分，并除以 1e6
        bigValue = new Big(integerPart + decimalPart).div(1e6);
      } else {
        // 没有小数点，直接除以 1e6
        bigValue = bigValue.div(1e6);
      }

      // 保留小数点后指定的位数并向上取整
      bigValue = bigValue.round(fix, Big.roundUp);

      // 将结果转换为字符串并移除末尾的0
      let [intPart, decPart] = bigValue
        .toFixed(fix)
        .replace(/(\.[0-9]*[1-9])0+$|\.0*$/, "$1")
        .split(".");

      // 添加千位分隔符
      intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // 合并整数部分和小数部分
      let result = decPart ? `${intPart}.${decPart}` : intPart;

      // 如果小数点后部分都是零则去掉
      if (decPart && decPart.replace(/0+$/, "") === "") {
        result = intPart;
      }

      return result;
    },
    formatNumber(num, fix) {
      // 先将数值除以 1,000,000
      num = num / 1000000;

      // 如果结果小数位数不超过 fix，直接返回
      if (num.toString().split(".")[1]?.length <= fix) {
        return num.toLocaleString("en-US", { maximumFractionDigits: fix });
      }

      // 计算 multiplier
      const multiplier = Math.pow(10, fix);
      // 先将 num 乘以 multiplier，然后向上取整，再除以 multiplier
      const roundedNum = Math.ceil(num * multiplier) / multiplier;
      // 将结果转换为字符串并移除末尾的0
      let [integerPart, decimalPart] = roundedNum
        .toFixed(fix)
        .replace(/(\.[0-9]*[1-9])0+$|\.0*$/, "$1")
        .split(".");
      // 添加千位分隔符
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // 合并整数部分和小数部分
      return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
    },
    convertHash(Hash) {
      const part1 = Hash.slice(0, 6);
      const part2 = Hash.slice(-6);

      return `${part1}******${part2}`;
    },

    convertDate(time) {
      const date = new Date(time);

      const padZero = (num) => (num < 10 ? "0" : "") + num;

      const month = padZero(date.getMonth() + 1);
      const day = padZero(date.getDate());
      const year = date.getFullYear();

      const hours = padZero(date.getHours());
      const minutes = padZero(date.getMinutes());
      const seconds = padZero(date.getSeconds());

      return `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;
    },

    // 表格
    // fetchInitialData() {
    //   this.tableLoading = true;
    //   Promise.all([this.fetchTotalItems1(), this.fetchTotalItems2()])
    //     .then(() => {
    //       this.totalItems = this.totalItems1 + this.totalItems2;
    //       if(totalItems1>10&&this.totalItems2>0){
    //         this.totalItems=this.totalItems+10
    //       }else if(this.totalItems1>0&&this.totalItems1<10&&this.totalItems2>10){
    //         this.totalItems=this.totalItems+10
    //       }else if(this.totalItems1+this.totalItems2==10){
    //         this.totalItems=this.totalItems+10
    //       }else if((this.totalItems1+this.totalItems2<10)&&this.totalItems1>0&&this.totalItems2>0){
    //         this.totalItems=this.totalItems+10
    //       }
    //       // if((totalItems1>10&&this.totalItems2>0)||(this.totalItems1>0&&this.totalItems1<10&&this.totalItems2>10)||(this.totalItems1+this.totalItems2==10)||((this.totalItems1+this.totalItems2<10)&&this.totalItems1>0&&this.totalItems2>0)){
    //       //   this.totalItems=this.totalItems+10
    //       // }
    //       this.totalItems1IsExact = this.totalItems1 % this.pageSize === 0;
    //       this.fetchData1(1);
    //       this.tableLoading = false;
    //     })
    //     .catch((error) => {
    //       this.tableLoading = false;
    //     });
    //     console.log(this.totalItems)
    // },
    mergeData() {
      this.mergedData = [];
      this.mergedData = [...this.data1, ...this.data2];
      this.mergedData.sort((a, b) => new Date(b.time) - new Date(a.time)); // 按时间降序排列
    },
    fetchInitialData() {
      this.tableLoading = true;
      Promise.all([this.fetchTotalItems1(), this.fetchTotalItems2()])
        .then(() => {
          this.totalItems = this.totalItems1 + this.totalItems2;

          if (
            (this.totalItems1 > 10 && this.totalItems2 > 0) ||
            (this.totalItems1 > 0 &&
              this.totalItems1 < 10 &&
              this.totalItems2 > 10) ||
            this.totalItems1 + this.totalItems2 == 10 ||
            (this.totalItems1 + this.totalItems2 < 10 &&
              this.totalItems1 > 0 &&
              this.totalItems2 > 0)
          ) {
            this.totalItems = this.totalItems + 10;
          }

          if (Number(this.totalItems1) > 0) {
            this.fetchData1(1);
          } else if (Number(this.totalItems1) == 0) {
            this.fetchData2(1, 10);
          }
          this.tableLoading = false;
        })
        .catch((error) => {
          this.tableLoading = false;
        });
    },
    fetchTotalItems1() {
      let params = {
        events: `message.sender='${this.address}'`,
        page: 1,
        limit: 1, // 只需获取总数
      };
      return this.$api
        .getTransactions(params)
        .then((response) => {
          this.totalItems1 = Number(response.data.total);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchTotalItems2() {
      let params = {
        events: `transfer.recipient='${this.address}'`,
        page: 1,
        limit: 1, // 只需获取总数
      };
      return this.$api
        .getTransactions(params)
        .then((response) => {
          this.totalItems2 = Number(response.data.total);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchData1(page) {
      let params = {
        events: `message.sender='${this.address}'`,
        page: page,
        limit: this.pageSize,
      };
      return this.$api
        .getTransactions(params)
        .then((response) => {
          this.data1 = response.data.tx_responses.map((item, index) =>
            this.transformData(
              item,
              response.data.txs[index].auth_info.fee.amount[0].amount
            )
          );
          this.mergeData();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchData2(page, size) {
      let params = {
        events: `transfer.recipient='${this.address}'`,
        page: page,
        limit: size,
      };
      return this.$api
        .getTransactions(params)
        .then((response) => {
          console.log(response.data);
          this.data2 = response.data.tx_responses.map((item, index) =>
            this.transformData(
              item,
              response.data.txs[index].auth_info.fee.amount[0].amount
            )
          );
          this.mergeData();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    transformData(item, feeCount) {
      console.log(feeCount);
      let amountNum = 0;

      // 安全访问 amount 字段，并根据其类型处理
      const amountField = item?.tx?.body?.messages?.[0]?.amount;

      if (Array.isArray(amountField) && amountField.length > 0) {
        amountNum = amountField[0]?.amount || 0;
      } else if (typeof amountField === "object" && amountField !== null) {
        amountNum = amountField.amount || 0;
      }
      return {
        txHash: item.txhash,
        block: item.height,
        time: this.convertDate(item.timestamp),
        from: item.tx.body.messages[0].from_address || "",
        to: item.tx.body.messages[0].to_address || "",
        amount: this.formatNumber(amountNum, 6),
        fee: this.formatNumber(feeCount, 6),
        state: item.code,
      };
    },
    // getTransactions() {
    //   this.tableLoading = true;
    //   let params = {
    //     // events: `message.sender='${this.address}'`,
    //     events: `transfer.recipient='${this.address}'`,
    //     page: this.currentPage,
    //     limit: 10,
    //   };
    //   this.$api.getTransactions(params).then((response) => {
    //     this.tableLoading = false;
    //     this.total = Number(response.data.total);
    //     // if (response.data.total > 0) {
    //     //   let list = [];
    //     //   response.data.tx_responses.map((item) => {
    //     //     console.log(item.tx.auth_info.fee.amount[0])
    //     //     let obj = {
    //     //       txHash: item.txhash,
    //     //       block: item.height,
    //     //       time: this.convertDate(item.timestamp),
    //     //       from: item.tx.body.messages[0].from_address,
    //     //       to: item.tx.body.messages[0].to_address,
    //     //       amount:
    //     //         item.tx.body.messages[0].amount[0].amount,

    //     //       fee: item.tx.auth_info.fee.amount[0].amount,
    //     //       state: item.code,
    //     //     };
    //     //     list.push(obj);
    //     //   });
    //     //   this.tableData = list;

    //     // }
    //   });
    // },
    generateQRCode() {
      QRCode.toDataURL(this.address)
        .then((url) => {
          this.qrCodeUrl = url;
        })
        .catch((error) => {});
    },
    handleCurrentChange(page) {
      // const totalPage1 = Math.ceil(this.totalItems1 / this.pageSize);
      this.data1 = [];
      this.data2 = [];

      if (this.totalItems1 > 0) {
        const totalPage1 = Math.ceil(this.totalItems1 / this.pageSize);
        if (page <= totalPage1) {
          // 如果在 fetchData1 的范围内，只需要请求 fetchData1
          // this.fetchData1(page);
          // if(this.totalItems1IsExact){
          //   this.fetchData2Page=page-2
          //   this.fetchData2(this.fetchData2Page,10);
          // }else{
          //   if(page < totalPage1){
          this.fetchData1(page);
          //   }else{
          //     const remaining=10 - (this.totalItems1-((page-1)*this.pageSize))
          //   Promise.all([
          //     this.fetchData1(totalPage1),
          //     this.fetchData2(1, remaining),
          //   ]);
          //   }
          // }
        } else {
          // 如果超出 fetchData1 的范围，需要同时请求 fetchData1 和 fetchData2
          // const remaining=10 - (this.totalItems1-((page-1)*this.pageSize))
          // const remaining = this.pageSize - (this.totalItems1 % this.pageSize);
          //当前请求页=请求1的向上取整最大页面+1&&
          // if (page === totalPage1 && remaining > 0) {
          //   // 请求 fetchData2 的前 remaining 条数据
          //   Promise.all([
          //     this.fetchData1(totalPage1),
          //     this.fetchData2(1, remaining),
          //   ]);
          // } else {
          let requirePage = page - totalPage1;
          // if(page-2==0){
          //   requirePage=page
          // }else{
          //   requirePage=page-2
          // }
          this.fetchData2Page = requirePage;
          this.fetchData2(this.fetchData2Page, 10);
          // }
        }
      } else {
        this.fetchData2(page, 10);
      }
      this.currentPage = page;
    },
    handleChange() {
      // this.currentPage=this.jumperValue
      if (this.jumperValue > parseFloat(this.total / 10)) {
        this.jumperValue = 0;
        return;
      }
      this.handleCurrentChange(Number(this.jumperValue));
    },
    divideAndFormat(number) {
      const result = number / 1000000;
      return result.toFixed(6);
    },
    getBalances() {
      let params = {
        address: this.address,
        denom: "ucnho",
      };
      this.$api.getBalances(params).then((response) => {
        this.loading = false;
        // this.balance = response.data.balance.amount / 1000000;
        this.balance = this.balanceNumber(response.data.balance.amount, 7);
      });
    },
    getAccounts() {
      this.$api.getAccounts(this.address).then((response) => {
        this.generateQRCode();
        this.getBalances();
        // this.getTransactions();
        this.fetchInitialData();
      });
    },
    getAccounts2() {
      this.$api
        .getAccounts(this.searchQuery)
        .then((response) => {
          let id = this.searchQuery;
          this.$router.push({ name: "Account", params: { id } });
          window.location.reload();
          // this.generateQRCode()
          // this.getBalances();
          // this.getTransactions()
        })
        .catch((error) => {
          if (error) this.txsHash(this.searchQuery);
        });
    },
    txsHash(id) {
      let params = {
        hash: id,
      };
      this.$api
        .txsHash(params)
        .then((response) => {
          let id = this.searchQuery;
          this.$router.push({ name: "Transaction", params: { id } });
        })
        .catch((error) => {
          // this.$router.push({ name: "Nothing", params: { id } });
          if (id.startsWith("chno")) {
            this.$router.push({ name: "Nothing", params: { id } });
          } else {
            this.$router.push({ name: "TxNothing", params: { id } });
          }
        });
    },
    claimToken() {
      if (!this.searchQuery) return;
      this.getAccounts2();
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success("Copied to clipboard");
      });
    },
    toggleDetails() {
      this.showDetails = !this.showDetails;
      if (this.showDetails) {
        this.messageButton = "Hide details";
      } else {
        this.messageButton = "View more details";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 16px;
  text-align: left;
  .title {
    font-size: 35px;
    font-weight: 900;
    color: #000;
    margin-bottom: 8px;
  }
  .title2 {
    display: flex;
    align-items: center;
    img {
      width: 20px;
      margin-left: 4px;
    }
  }
  .search-box {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 2px;
    width: 560px;
  }
  .claim-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #cbe6de;
    color: #fff;
    border-radius: 5px;
    width: 76px;
    height: 38px;
    cursor: pointer;
    img {
      width: 30px;
    }
  }
  .claim-button-active {
    background-color: #018761 !important;
  }
}

.search-input {
  max-width: 300px;
}
.qrcode {
  img {
    width: 180px;
    margin-bottom: -2px;
  }
}
.content {
  display: flex;
  justify-content: center;
  .transaction-details {
    width: 1400px;
    max-width: 1400px;
  }
  .copy {
    cursor: pointer;
  }
}
.balance-box {
  background: #fff;
  border-radius: 12px;
  padding: 24px 16px;
  text-align: left;
  margin-bottom: 12px;
  .title {
    font-size: 20px;
    margin-bottom: 4px;
    font-weight: 900;
  }
  .title2 {
    font-size: 17px;
  }
}

.message-box {
  background: #fff;
  border-radius: 12px;
  padding: 24px 12px;
  margin-top: 12px;
  margin-bottom: 60px;
  .hideButton {
    color: #018761;
    font-size: 15px;
    margin-left: 36px;
    font-weight: 600;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: 4px;
    img {
      width: 16px;
      margin-left: 6px;
    }
  }
  .title {
    font-weight: 900;
    text-align: left;
    display: flex;
    align-items: center;
    span {
      font-size: 20px;
    }
  }
  .message-detail-box {
    background: #f2f2f2;
    border-radius: 8px;
    padding: 24px 16px;
    text-align: left;
  }
}
.info-box {
  background: #fff;
  border-radius: 12px;
  padding: 24px 12px;
  .title {
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 900;
    text-align: left;
  }
  .info-details-box {
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 24px 16px;
    .green {
      color: #028760;
    }
    .red {
      color: #ba2636;
    }
    .item-box {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      text-align: left;
      .label {
        width: 120px;
        font-weight: 600;
        margin-right: 36px;
      }
      .details {
        display: flex;
        align-items: center;
        .stateImg {
          width: 20px;
          margin-right: 6px;
        }
        .copy {
          width: 20px;
          margin-left: 6px;
          cursor: pointer;
        }
      }
    }
  }
  .table {
    font-size: 15px;
    .el-table tr {
      background: #eee;
    }
  }
  .table-data {
    display: flex;
    align-items: center;
    .green {
      color: #028760;
      cursor: pointer;
    }
    img {
      width: 20px;
      margin-left: 4px;
    }
  }
  .page-box {
    display: flex;
    align-items: center;
    margin: 28px 0 36px;
    justify-content: center;
    span {
      font-size: 15px;
    }
    .jumper-box {
      display: flex;
      align-items: center;
      margin-left: 72px;
      .jumper-input {
        width: 108px;
        border-radius: 8px;
        border-color: #eee;
        margin-left: 4px;
      }
    }
  }
}

.box-card {
  margin-bottom: 20px;
}

.success {
  color: green;
}

.copyable {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}
</style>
<style>
.table {
  border-radius: 8px 8px 0 0;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}
.table .has-gutter {
  color: #000;
  font-weight: 600;
}
.table .has-gutter th {
  background-color: #eeeeee;
}
.account-pagination .number,
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  font-size: 15px;
  width: 36px;
  height: 36px;
  max-width: 36px;
  max-height: 36px;
  line-height: 36px;
  border-radius: 6px;
}
.account-pagination .el-pager li:not(.disabled).active {
  background-color: #38b48b !important;
}
.account-pagination .el-pager li:not(.disabled):hover {
  background-color: #38b48b !important;
  color: #fff !important;
}
.copyTips {
  border: 0 !important;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px !important;
}
.table .el-table__row .el-table__cell {
  padding: 16px 0;
  font-size: 15px;
}
.table .el-table__row:hover td.el-table__cell {
  background-color: #f2f2f2 !important;
}
</style>
